'use client'

import { SEARCH_DATA } from '@/config/search-data'
import { useState } from 'react'

import { DesktopMenu } from '../navigation/desktop-menu'
import { MainMenu } from '../navigation/main-menu'
import { MobileMenu } from '../navigation/mobile-menu'
import { BrandLogo } from '../shared/brand-logo'
import { Search } from '../shared/search'
import { BurgerButton } from '../ui/burger-button'
import { DesktopBurgerButton } from '../ui/desktop-burger-button'
import { LanguageSwitcher } from '../ui/language-switcher'

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isDesktopMenuOpen, setIsDesktopMenuOpen] = useState(false)

  const toggleDesktopMenu = () => {
    if (!isDesktopMenuOpen) {
      setIsDesktopMenuOpen(true)
    } else {
      setIsDesktopMenuOpen(false)
    }
  }

  const closeDesktopMenu = () => {
    setIsDesktopMenuOpen(false)
  }

  return (
    <header className="fixed top-0 right-0 left-0 z-10 border-b border-gray-200 bg-white px-4 py-4 lg:py-6.5">
      <div className="mx-auto flex max-w-[1440px] items-center">
        <BrandLogo mode="dark" className="mr-12" />

        <div className="mr-4 flex w-full items-center gap-4">
          <div className="hidden min-[1370px]:block">
            <MainMenu />
          </div>
          <div className="ml-auto hidden gap-4 min-[768px]:flex">
            <Search
              className="max-w-[200px] max-[1370px]:max-w-[650px]"
              inputBg="bg-gray-50"
              options={SEARCH_DATA}
            />
            <LanguageSwitcher />
          </div>
        </div>

        <div className="ml-auto hidden items-center gap-4 max-[1369px]:flex max-[727px]:hidden min-[768px]:flex min-[1370px]:hidden">
          <DesktopBurgerButton
            onClick={toggleDesktopMenu}
            isOpen={isDesktopMenuOpen}
          />
          <DesktopMenu
            isOpen={isDesktopMenuOpen}
            onClick={closeDesktopMenu}
            onClose={closeDesktopMenu}
          />
        </div>

        <div className="ml-auto block min-[727px]:hidden">
          <BurgerButton
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          />
          <MobileMenu
            isOpen={isMobileMenuOpen}
            onClose={() => setIsMobileMenuOpen(false)}
          />
        </div>
      </div>
    </header>
  )
}
